import { useLanguage } from '@api/application-configuration';

/**
 * Maps app language codes (e.g., 'sv', 'en') to ECharts locale codes.
 * ECharts locales must be registered in src/providers/provider.tsx
 */
const ECHARTS_LOCALE_MAP: Record<string, string> = {
  sv: 'SV',
  'sv-SE': 'SV',
  en: 'EN',
  'en-US': 'EN',
  'en-GB': 'EN'
};

const DEFAULT_ECHARTS_LOCALE = 'EN';

/**
 * Returns the ECharts locale code based on the current app language.
 * Falls back to 'EN' if the language is not mapped.
 */
export const useEchartsLocale = (): string => {
  const language = useLanguage();

  if (!language) {
    return DEFAULT_ECHARTS_LOCALE;
  }

  // Try exact match first, then language prefix
  return (
    ECHARTS_LOCALE_MAP[language] ??
    ECHARTS_LOCALE_MAP[language.split('-')[0]] ??
    DEFAULT_ECHARTS_LOCALE
  );
};

/**
 * Get ECharts locale from a language string (non-hook version for static contexts)
 */
export const getEchartsLocale = (language?: string): string => {
  if (!language) {
    return DEFAULT_ECHARTS_LOCALE;
  }

  return (
    ECHARTS_LOCALE_MAP[language] ??
    ECHARTS_LOCALE_MAP[language.split('-')[0]] ??
    DEFAULT_ECHARTS_LOCALE
  );
};
